import { humanize } from '@zoocasa/node-kit/strings';

// Ideally we should only have one CountryCodeList type, but we need to use this for now
// for the sake of a priority ticket. According to Cursor, adding country codes to the original
// type would require changes that could affect 81 files (user context, site location, 
// type assertions / definitions, etc) which is not ideal for a push right before Christmas :/
export const UI_COUNTRY_CODE_LIST = {
  CANADA: 'CA',
  UNITED_STATES: 'US',
  AUSTRALIA: 'AU',
  BRAZIL: 'BR',
  CHILE: 'CL',
  COLOMBIA: 'CO',
  DOMINICAN_REPUBLIC: 'DO',
  ECUADOR: 'EC',
  FRANCE: 'FR',
  GERMANY: 'DE',
  HONG_KONG: 'HK',
  INDIA: 'IN',
  ISRAEL: 'IL',
  ITALY: 'IT',
  JAPAN: 'JP',
  SOUTH_KOREA: 'KR',
  LUXEMBOURG: 'LU',
  MEXICO: 'MX',
  NETHERLANDS: 'NL',
  NEW_ZEALAND: 'NZ',
  PERU: 'PE',
  POLAND: 'PL',
  PORTUGAL: 'PT',
  PUERTO_RICO: 'PR',
  ROMANIA: 'RO',
  SOUTH_AFRICA: 'ZA',
  SPAIN: 'ES',
  TURKIYE: 'TR',
  UNITED_ARAB_EMIRATES: 'AE',
  UNITED_KINGDOM: 'GB'
} as const;

export type UiCountryCode = (typeof UI_COUNTRY_CODE_LIST)[keyof typeof UI_COUNTRY_CODE_LIST];
// TODO: Refactor our codebase to make it more robust, such that in the future
// we can add a tenant country to CountryCodeList without having to change files everwhere
export enum CountryCodeList {
  // Tenant Codes
  CANADA = 'CA',
  UNITED_STATES = 'US'
}

export type CountryCode = CountryCodeList;

export function convertStringToCountryCode(value: string): CountryCodeList | undefined {
  return (Object.values(CountryCodeList) as Array<string>).includes(value) ? (value as CountryCodeList) : undefined;
}

/**
 * Gets the country name from its code.
 *
 * @param code The country code to get the name for
 * @returns The country name if the code is valid, otherwise
 *  the code itself as an {@link humanize humanized} string
 */
export function getCountryName(code: string): string {
  switch (code.toUpperCase()) {
    case CountryCodeList.CANADA:
      return 'Canada';
    case CountryCodeList.UNITED_STATES:
      return 'USA';
    default:
      return humanize(code);
  }
}
